import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import {useMutation, useQueryClient} from "react-query";

import {requestAnswersMatrix} from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {CandidateFilterParams} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {saveByteArray} from "../../shared/Utils";

const DownloadAnswersMatrix = (props: CandidateFilterParams ) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const downloadMatrix = useMutation(()=>requestAnswersMatrix(props), {
    onSuccess: (TData) => {
      successToast(toast, "Descargando respuestas");
      saveByteArray("Answers Matrix "+props.testName+" "+props.startDateValue, TData.data);
      return queryClient.invalidateQueries(adminKeys.candidateAnswers());
    },
    onError: () => {
      errorToast(toast, "Error descargando respuestas");
    },
  });

  return (
      <>
        <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen} disabled={!props.testName}>
          Descargar Matriz de respuestas
        </Button>
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Descargar respuestas</ModalHeader>
            <ModalCloseButton />
            <ModalFooter>
              <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadMatrix.mutate()}
              >
                Descargar Matriz
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default DownloadAnswersMatrix;
